/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */
import { IDomainModel } from './domain-model.interface';

import { ComponentTypes } from './component-type.domain';
import { ContainerAccessControls } from './container-access-control.domain';
import { ContainerAccessPolicies } from './container-access-policy.domain';
import { ContainerTagKeys } from './container-tag-key.domain';
import { ContainerTypes } from './container-type.domain';
import { ContentHosts } from './content-host.domain';
import { ContentItemTypes } from './content-item-type.domain';
import { CurriculumLevels } from './curriculum-level.domain';
import { ExternalResourceTypes } from './external-resource-type.domain';
import { MediaItemTypes } from './media-item-type.domain';
import { PublishStatuses } from './publish-status.domain';
import { QuizQuestionPartFormats } from './quiz-question-part-format.domain';
import { QuizQuestionTypes } from './quiz-question-type.domain';
import { AddressTypes } from './address-type.domain';
import { BillingFrequencies } from './billing-frequency.domain';
import { CancellationReasons } from './cancellation-reason.domain';
import { Countries } from './country.domain';
import { Currencies } from './currency.domain';
import { EducationLevels } from './education-level.domain';
import { EftRecordTypes } from './eft-record-type.domain';
import { IdentityClaimTypes } from './identity-claim-type.domain';
import { IdentityProviders } from './identity-provider.domain';
import { InstitutionTypes } from './institution-type.domain';
import { NotificationScheduleTypes } from './notification-schedule-type.domain';
import { NotificationTypes } from './notification-type.domain';
import { PaymentCardTypes } from './payment-card-type.domain';
import { PaymentGateways } from './payment-gateway.domain';
import { PaymentInstrumentTypes } from './payment-instrument-type.domain';
import { PaymentTransactionStatuses } from './payment-transaction-status.domain';
import { PaymentTransactionTypes } from './payment-transaction-type.domain';
import { StateProvinces } from './state-province.domain';
import { SubscriptionStatuses } from './subscription-status.domain';
import { ProfileActivityTypes } from './profile-activity-type.domain';
import { AchievementTypes } from './achievement-type.domain';
import { Completions } from './completion.domain';
import { EvaluationContexts } from './evaluation-context.domain';
import { EvaluationTypes } from './evaluation-type.domain';
import { Performances } from './performance.domain';
export * from './component-type.domain';
export * from './container-access-control.domain';
export * from './container-access-policy.domain';
export * from './container-tag-key.domain';
export * from './container-type.domain';
export * from './content-host.domain';
export * from './content-item-type.domain';
export * from './curriculum-level.domain';
export * from './external-resource-type.domain';
export * from './media-item-type.domain';
export * from './publish-status.domain';
export * from './quiz-question-part-format.domain';
export * from './quiz-question-type.domain';
export * from './address-type.domain';
export * from './billing-frequency.domain';
export * from './cancellation-reason.domain';
export * from './country.domain';
export * from './currency.domain';
export * from './education-level.domain';
export * from './eft-record-type.domain';
export * from './identity-claim-type.domain';
export * from './identity-provider.domain';
export * from './institution-type.domain';
export * from './notification-schedule-type.domain';
export * from './notification-type.domain';
export * from './payment-card-type.domain';
export * from './payment-gateway.domain';
export * from './payment-instrument-type.domain';
export * from './payment-transaction-status.domain';
export * from './payment-transaction-type.domain';
export * from './state-province.domain';
export * from './subscription-status.domain';
export * from './profile-activity-type.domain';
export * from './achievement-type.domain';
export * from './completion.domain';
export * from './evaluation-context.domain';
export * from './evaluation-type.domain';
export * from './performance.domain';

export const Lookups: IDomainModel[][] = new Array<IDomainModel[]>(
   ComponentTypes,
   ContainerAccessControls,
   ContainerAccessPolicies,
   ContainerTagKeys,
   ContainerTypes,
   ContentHosts,
   ContentItemTypes,
   CurriculumLevels,
   ExternalResourceTypes,
   MediaItemTypes,
   PublishStatuses,
   QuizQuestionPartFormats,
   QuizQuestionTypes,
   AddressTypes,
   BillingFrequencies,
   CancellationReasons,
   Countries,
   Currencies,
   EducationLevels,
   EftRecordTypes,
   IdentityClaimTypes,
   IdentityProviders,
   InstitutionTypes,
   NotificationScheduleTypes,
   NotificationTypes,
   PaymentCardTypes,
   PaymentGateways,
   PaymentInstrumentTypes,
   PaymentTransactionStatuses,
   PaymentTransactionTypes,
   StateProvinces,
   SubscriptionStatuses,
   ProfileActivityTypes,
   AchievementTypes,
   Completions,
   EvaluationContexts,
   EvaluationTypes,
   Performances,
);
